'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { useContext, createContext } from 'react';

function createSafeContext(error, defaultValue) {
    var Context = /*#__PURE__*/ createContext(defaultValue || null);
    var useSafeContext = function() {
        var context = useContext(Context);
        if (context === null) {
            throw error;
        }
        return context;
    };
    var Provider = function(param) {
        var children = param.children, value = param.value;
        return /*#__PURE__*/ jsx(Context.Provider, {
            value: value,
            children: children
        });
    };
    return [
        Provider,
        useSafeContext
    ];
}

export { createSafeContext };
